const fastlyLoader = ({ src, width, quality = 80 }) => `${process.env.CVNA_APP_CDN_URL}${src}?width=${width}&quality=${quality}`;

export default fastlyLoader;
